var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlus = function SvgPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 9,
    "data-width-20": 12,
    "data-width-24": 14,
    viewBox: "0 0 9 9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.148 8.852c.094.093.22.146.352.148a.507.507 0 0 0 .5-.5V5h3.5a.5.5 0 1 0 0-1H5V.5a.5.5 0 0 0-1 0V4H.5a.5.5 0 0 0 0 1H4v3.5a.5.5 0 0 0 .148.352",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export default ForwardRef;